import { Link, useLocation } from "react-router-dom";
import React, { useState } from "react";
import "./EditProductCss/EditProduct.css";
import AdminLayout from "../AdminLayout";

const EditProduct = () => {
  const dataArr = useLocation().state.rowData;
  const editType = useLocation().state.tableType;

  // State for managing toggle checkbox and the count
  const [isToggleChecked, setIsToggleChecked] = useState(false);
  //   const [count, setCount] = useState(0);

  // Handle toggle change
  const handleToggleChange = () => {
    setIsToggleChecked(!isToggleChecked);
  };

  const [count, setCount] = useState(0);
  const rows = new Array(count).fill(null);

  function handleSvgClick() {
    // Perform additional actions when the SVG icon is clicked
    console.log("SVG icon clicked!");

    // Trigger the file upload programmatically
    document.getElementById("fileUpload").click();
  }

  function handleFileUpload(event) {
    const files = event.target.files; // Access the uploaded files
    if (files.length > 0) {
      const file = files[0];
      console.log("Uploaded file:", file);

      // Additional logic for processing the file
      // Example: Display it in a gallery or upload to the server
    }
  }

  return (
    <div>
      <AdminLayout>
        <div className="container">
          <div className="edit_product_wepper">
            <div className="edit_product_inner_wepper">
              <div className="row">
                <div className="col-lg-6">
                  <div className="product_user">
                    <img
                      src={dataArr?.product_images[0]?.image_url}
                      alt="img does not loaded"
                    />
                    <div>
                      <h4>{dataArr?.name}</h4>
                      <span>
                        Price = {dataArr?.price} <br /> Quantity ={" "}
                        {dataArr?.quantity}
                      </span>
                    </div>
                  </div>
                </div>
                {/* <div className="col-lg-3 edit_profile_togle">
                  <div className="toggle-container">
                    <div className="toggle-row">
                      <label className="label" htmlFor="toggle1">
                        Show image
                      </label>
                      <label className="switch">
                        <input type="checkbox" id="toggle1" />
                        <span className="slider"></span>
                      </label>
                    </div>
                    <div className="toggle-row">
                      <label className="label" htmlFor="toggle2">
                        Hide text
                      </label>
                      <label className="switch">
                        <input type="checkbox" id="toggle2" />
                        <span className="slider"></span>
                      </label>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

            <div className="edit_Product_information_wepper">
              <h3>{editType} Information</h3>
              <form action="">
                <div className="row from_wepper">
                  <div className="col-lg-6">
                    <div className="form-group ">
                      <label htmlFor="fname">First Name</label>
                      <div className="add_user_input">
                        <input
                          type="text"
                          name="fname"
                          className="form-control"
                          placeholder="Jone"
                          fdprocessedid="agqwgl"
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_771_7773)">
                            <path
                              d="M12.6667 4.66733C12.6667 7.244 10.5773 9.334 8 9.334C5.42267 9.334 3.33333 7.244 3.33333 4.66733C3.33333 2.08933 5.42267 0 8 0C10.5773 0 12.6667 2.08933 12.6667 4.66733V4.66733ZM11.6013 9.454C10.5973 10.212 9.352 10.6673 8 10.6673C6.64667 10.6673 5.40067 10.2107 4.39533 9.45267C1.68067 10.648 0 14.37 0 16H16C16 14.3847 14.2667 10.6627 11.6013 9.454V9.454Z"
                              fill="#6F757E"
                            ></path>
                          </g>
                          <defs>
                            <clipPath id="clip0_771_7773">
                              <rect width="16" height="16" fill="white"></rect>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group ">
                      <label htmlFor="fname">Weight</label>
                      <div className="add_user_input">
                        <input
                          type="text"
                          name="fname"
                          className="form-control"
                          placeholder="2"
                          fdprocessedid="agqwgl"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="fname">Category</label>
                      <div className="add_user_input">
                        <select
                          name="cars"
                          id="cars"
                          className="form-control"
                          fdprocessedid="v7zr7"
                        >
                          <option defaultValue>Clothing</option>
                          <option defaultValue="2125">2125</option>
                          <option defaultValue="2125">2125</option>
                        </select>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="10"
                          viewBox="0 0 18 10"
                          fill="none"
                        >
                          <path
                            d="M2 1.5L9 8.5L16 1.5"
                            stroke="#26395C"
                            strokeWidth="2"
                            strokeLinecap="square"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="fname">Size</label>
                      <div className="add_user_input">
                        <select
                          name="cars"
                          id="cars"
                          className="form-control"
                          fdprocessedid="v7zr7"
                        >
                          <option defaultValue>5 Feet</option>
                          <option defaultValue="2125">2125</option>
                          <option defaultValue="2125">2125</option>
                        </select>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="10"
                          viewBox="0 0 18 10"
                          fill="none"
                        >
                          <path
                            d="M2 1.5L9 8.5L16 1.5"
                            stroke="#26395C"
                            strokeWidth="2"
                            strokeLinecap="square"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="text-end">
                    <button type="submit">Save</button>
                  </div>
                </div>
              </form>
            </div>
            <div className="edit_media_file_wepper">
              <div className="edit_media_file_inner_hedding">
                <h2>Media Files</h2>
                <Link to="#">Upload more files</Link>
              </div>
              <div className="edit_media_box_wepper">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="media_edit_img">
                      <img src="images/product-user.png" alt="" />
                      <div>
                        <p>Minimal soofa.jpg</p>
                        <span>35 Kb</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="edit_media_edit_btn">
                      <div className="edit_media_pen_edit">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSvgClick()}
                        >
                          <path
                            d="M0.986667 8.43925C0.0973334 11.0499 0 11.2606 0 11.4972C0 11.8492 0.306667 11.9966 0.499333 11.9966C0.734 11.9966 0.944667 11.9052 3.54867 11.0019L0.986667 8.43925ZM1.69333 7.73192L4.25733 10.2959L11.8047 2.75525C11.9347 2.62525 12 2.45525 12 2.28392C12 2.11392 11.9347 1.94392 11.8047 1.81325C11.3433 1.35258 10.6433 0.653249 10.1813 0.191916C10.0513 0.0619155 9.88067 -0.00341797 9.71 -0.00341797C9.54067 -0.00341797 9.37 0.0619155 9.23933 0.191916L1.69333 7.73192Z"
                            fill="#10849B"
                          />
                        </svg>
                        <input
                          type="file"
                          id="fileUpload"
                          className="file_input"
                          style={{ display: "none" }}
                          onChange={(e) => handleFileUpload(e)}
                        />
                      </div>
                      <div className="edit_media_pen_edit">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M13.3451 4.3375H2.67839V13.9528C2.67839 14.3468 2.97705 14.6668 3.34505 14.6668H12.6784C13.0464 14.6668 13.3451 14.3468 13.3451 13.9528C13.3451 11.3495 13.3451 4.3375 13.3451 4.3375V4.3375ZM9.51172 6.00016C9.78772 6.00016 10.0117 6.22416 10.0117 6.50016V12.1668C10.0117 12.4428 9.78772 12.6668 9.51172 12.6668C9.23572 12.6668 9.01172 12.4428 9.01172 12.1668V6.50016C9.01172 6.22416 9.23572 6.00016 9.51172 6.00016ZM6.51172 6.00016C6.78772 6.00016 7.01172 6.22416 7.01172 6.50016V12.1668C7.01172 12.4428 6.78772 12.6668 6.51172 12.6668C6.23572 12.6668 6.01172 12.4428 6.01172 12.1668V6.50016C6.01172 6.22416 6.23572 6.00016 6.51172 6.00016ZM6.01172 2.66683V2.00016C6.01172 1.6435 6.32772 1.3335 6.67839 1.3335H9.34505C9.69572 1.3335 10.0117 1.6435 10.0117 2.00016V2.66683H13.5144C13.7891 2.66683 14.0117 2.89016 14.0117 3.16483C14.0117 3.4395 13.7891 3.66283 13.5144 3.66283H2.50972C2.23439 3.66283 2.01172 3.4395 2.01172 3.16483C2.01172 2.89016 2.23439 2.66683 2.50972 2.66683H6.01172ZM9.01172 2.66683V2.3335H7.01172V2.66683H9.01172Z"
                            fill="#10849B"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="edit_media_box_wepper">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="media_edit_img">
                      <img src="images/product-user.png" alt="" />
                      <div>
                        <p>Minimal soofa.jpg</p>
                        <span>35 Kb</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="edit_media_edit_btn">
                      <div className="edit_media_pen_edit">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSvgClick()}
                        >
                          <path
                            d="M0.986667 8.43925C0.0973334 11.0499 0 11.2606 0 11.4972C0 11.8492 0.306667 11.9966 0.499333 11.9966C0.734 11.9966 0.944667 11.9052 3.54867 11.0019L0.986667 8.43925ZM1.69333 7.73192L4.25733 10.2959L11.8047 2.75525C11.9347 2.62525 12 2.45525 12 2.28392C12 2.11392 11.9347 1.94392 11.8047 1.81325C11.3433 1.35258 10.6433 0.653249 10.1813 0.191916C10.0513 0.0619155 9.88067 -0.00341797 9.71 -0.00341797C9.54067 -0.00341797 9.37 0.0619155 9.23933 0.191916L1.69333 7.73192Z"
                            fill="#10849B"
                          />
                        </svg>
                        <input
                          type="file"
                          id="fileUpload"
                          className="file_input"
                          style={{ display: "none" }}
                          onChange={(e) => handleFileUpload(e)}
                        />
                      </div>
                      <div className="edit_media_pen_edit">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M13.3451 4.3375H2.67839V13.9528C2.67839 14.3468 2.97705 14.6668 3.34505 14.6668H12.6784C13.0464 14.6668 13.3451 14.3468 13.3451 13.9528C13.3451 11.3495 13.3451 4.3375 13.3451 4.3375V4.3375ZM9.51172 6.00016C9.78772 6.00016 10.0117 6.22416 10.0117 6.50016V12.1668C10.0117 12.4428 9.78772 12.6668 9.51172 12.6668C9.23572 12.6668 9.01172 12.4428 9.01172 12.1668V6.50016C9.01172 6.22416 9.23572 6.00016 9.51172 6.00016ZM6.51172 6.00016C6.78772 6.00016 7.01172 6.22416 7.01172 6.50016V12.1668C7.01172 12.4428 6.78772 12.6668 6.51172 12.6668C6.23572 12.6668 6.01172 12.4428 6.01172 12.1668V6.50016C6.01172 6.22416 6.23572 6.00016 6.51172 6.00016ZM6.01172 2.66683V2.00016C6.01172 1.6435 6.32772 1.3335 6.67839 1.3335H9.34505C9.69572 1.3335 10.0117 1.6435 10.0117 2.00016V2.66683H13.5144C13.7891 2.66683 14.0117 2.89016 14.0117 3.16483C14.0117 3.4395 13.7891 3.66283 13.5144 3.66283H2.50972C2.23439 3.66283 2.01172 3.4395 2.01172 3.16483C2.01172 2.89016 2.23439 2.66683 2.50972 2.66683H6.01172ZM9.01172 2.66683V2.3335H7.01172V2.66683H9.01172Z"
                            fill="#10849B"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-end">
                <button type="submit">Save</button>
              </div>
            </div>
            <div className="edit_social_links_wepper">
              <h3>Social links</h3>
              <form action="">
                <div className="row from_wepper">
                  <div className="col-lg-6">
                    <div className="form-group ">
                      <label htmlFor="fname">Facebook</label>
                      <div className="add_user_input">
                        <input
                          type="text"
                          name="fname"
                          className="form-control"
                          placeholder="Facebook.com/profile/aiden"
                          fdprocessedid="agqwgl"
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_179_6414)">
                            <path
                              d="M8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM10 5.33333H9.1C8.74133 5.33333 8.66667 5.48067 8.66667 5.852V6.66667H10L9.86067 8H8.66667V12.6667H6.66667V8H5.33333V6.66667H6.66667V5.128C6.66667 3.94867 7.28733 3.33333 8.686 3.33333H10V5.33333Z"
                              fill="#6F757E"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_179_6414">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group ">
                      <label htmlFor="fname">Twitter</label>
                      <div className="add_user_input">
                        <input
                          type="text"
                          name="fname"
                          className="form-control"
                          placeholder="Twitter.com/profile/aiden"
                          fdprocessedid="agqwgl"
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_179_6424)">
                            <path
                              d="M8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM12.044 6.43C12.166 9.12333 10.1573 12.126 6.60133 12.126C5.52 12.126 4.514 11.8087 3.66667 11.2653C4.68267 11.3853 5.69667 11.1027 6.50133 10.4727C5.664 10.4573 4.95667 9.90333 4.712 9.14267C5.01267 9.2 5.30867 9.18333 5.57733 9.11C4.65667 8.92467 4.02067 8.09533 4.04133 7.208C4.3 7.35133 4.59467 7.43733 4.90867 7.44733C4.056 6.87733 3.81467 5.75133 4.316 4.89067C5.26 6.04933 6.67133 6.81133 8.26267 6.89133C7.98333 5.694 8.892 4.54 10.1287 4.54C10.6787 4.54 11.1767 4.77267 11.526 5.14467C11.962 5.05933 12.3727 4.89933 12.742 4.68C12.5987 5.12733 12.2953 5.502 11.9 5.73933C12.2873 5.69267 12.6567 5.59 12.9993 5.43733C12.7433 5.82267 12.4193 6.16 12.044 6.43Z"
                              fill="#6F757E"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_179_6424">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="fname">Shoppify</label>
                      <div className="add_user_input">
                        <input
                          type="text"
                          name="fname"
                          className="form-control"
                          placeholder="Shoppify.com/profile/aiden"
                          fdprocessedid="agqwgl"
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14.014 3.08086C14.0007 3.00013 13.9211 2.95586 13.8547 2.95065C13.7883 2.94544 12.4987 2.92852 12.4987 2.92852C12.4987 2.92852 11.4187 2.00404 11.3124 1.90898C11.2062 1.81523 10.9982 1.84388 10.917 1.86471C10.9155 1.86471 10.7149 1.9207 10.374 2.01315C10.318 1.85039 10.2339 1.65117 10.1143 1.45065C9.73073 0.803516 9.1671 0.461068 8.4869 0.459766C8.48543 0.459766 8.48543 0.459766 8.48395 0.459766C8.43674 0.459766 8.38952 0.463672 8.34231 0.467578C8.32165 0.446745 8.30247 0.425912 8.28034 0.405078C7.98377 0.12513 7.60457 -0.0102862 7.14865 0.0014326C6.27075 0.023568 5.39579 0.583464 4.68609 1.57826C4.18738 2.27747 3.80671 3.15638 3.699 3.83737C2.69126 4.11341 1.98598 4.30612 1.96975 4.31003C1.46072 4.45065 1.44449 4.46497 1.37809 4.88815C1.33235 5.20716 0 14.297 0 14.297L11.1619 16.0001L16 14.9389C16 14.9389 14.0258 3.16159 14.014 3.08086ZM9.81483 2.1655C9.5581 2.23581 9.26595 2.31523 8.94873 2.40247C8.94283 2.01055 8.88971 1.46367 8.68167 0.992318C9.34858 1.103 9.67613 1.76836 9.81483 2.1655ZM8.36444 2.56263C7.78015 2.72279 7.14128 2.89727 6.50092 3.07175C6.68093 2.46367 7.02324 1.8569 7.44227 1.45977C7.59867 1.31133 7.81704 1.14727 8.07525 1.05352C8.3187 1.50013 8.37034 2.13425 8.36444 2.56263ZM7.16783 0.517058C7.3744 0.513151 7.54703 0.553516 7.69605 0.639453C7.4585 0.747526 7.2298 0.903776 7.01439 1.1069C6.45666 1.63555 6.02877 2.45456 5.85909 3.24622C5.32792 3.39076 4.80708 3.53398 4.32903 3.66419C4.63003 2.4194 5.81335 0.550912 7.16783 0.517058Z"
                            fill="#6F757E"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.8529 2.95052C13.7865 2.94531 12.4969 2.92839 12.4969 2.92839C12.4969 2.92839 11.4169 2.00391 11.3107 1.90885C11.2708 1.8737 11.2177 1.85547 11.1602 1.84766V15.9987L15.9967 14.9375C15.9967 14.9375 14.0226 3.16146 14.0108 3.08073C14.0004 3 13.9193 2.95573 13.8529 2.95052Z"
                            fill="#6F757E"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.48059 5.14578L7.91843 7.00124C7.91843 7.00124 7.29136 6.74994 6.5492 6.79031C5.4603 6.8515 5.4485 7.45697 5.45882 7.60932C5.51784 8.43874 7.99073 8.61973 8.1309 10.5637C8.24009 12.0924 7.21168 13.138 5.73031 13.2213C3.95237 13.3203 2.97266 12.3945 2.97266 12.3945L3.3489 10.9804C3.3489 10.9804 4.33452 11.6367 5.12242 11.5924C5.63736 11.5637 5.82179 11.194 5.80261 10.9322C5.72588 9.8502 3.71039 9.914 3.5835 8.13536C3.47579 6.63926 4.58977 5.12234 7.04791 4.98562C7.99663 4.93223 8.48059 5.14578 8.48059 5.14578Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="fname">Instagram</label>
                      <div className="add_user_input">
                        <input
                          type="text"
                          name="fname"
                          className="form-control"
                          placeholder="Instagram.com/profile/aiden"
                          fdprocessedid="agqwgl"
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14.014 3.08086C14.0007 3.00013 13.9211 2.95586 13.8547 2.95065C13.7883 2.94544 12.4987 2.92852 12.4987 2.92852C12.4987 2.92852 11.4187 2.00404 11.3124 1.90898C11.2062 1.81523 10.9982 1.84388 10.917 1.86471C10.9155 1.86471 10.7149 1.9207 10.374 2.01315C10.318 1.85039 10.2339 1.65117 10.1143 1.45065C9.73073 0.803516 9.1671 0.461068 8.4869 0.459766C8.48543 0.459766 8.48543 0.459766 8.48395 0.459766C8.43674 0.459766 8.38952 0.463672 8.34231 0.467578C8.32165 0.446745 8.30247 0.425912 8.28034 0.405078C7.98377 0.12513 7.60457 -0.0102862 7.14865 0.0014326C6.27075 0.023568 5.39579 0.583464 4.68609 1.57826C4.18738 2.27747 3.80671 3.15638 3.699 3.83737C2.69126 4.11341 1.98598 4.30612 1.96975 4.31003C1.46072 4.45065 1.44449 4.46497 1.37809 4.88815C1.33235 5.20716 0 14.297 0 14.297L11.1619 16.0001L16 14.9389C16 14.9389 14.0258 3.16159 14.014 3.08086ZM9.81483 2.1655C9.5581 2.23581 9.26595 2.31523 8.94873 2.40247C8.94283 2.01055 8.88971 1.46367 8.68167 0.992318C9.34858 1.103 9.67613 1.76836 9.81483 2.1655ZM8.36444 2.56263C7.78015 2.72279 7.14128 2.89727 6.50092 3.07175C6.68093 2.46367 7.02324 1.8569 7.44227 1.45977C7.59867 1.31133 7.81704 1.14727 8.07525 1.05352C8.3187 1.50013 8.37034 2.13425 8.36444 2.56263ZM7.16783 0.517058C7.3744 0.513151 7.54703 0.553516 7.69605 0.639453C7.4585 0.747526 7.2298 0.903776 7.01439 1.1069C6.45666 1.63555 6.02877 2.45456 5.85909 3.24622C5.32792 3.39076 4.80708 3.53398 4.32903 3.66419C4.63003 2.4194 5.81335 0.550912 7.16783 0.517058Z"
                            fill="#6F757E"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.8529 2.95052C13.7865 2.94531 12.4969 2.92839 12.4969 2.92839C12.4969 2.92839 11.4169 2.00391 11.3107 1.90885C11.2708 1.8737 11.2177 1.85547 11.1602 1.84766V15.9987L15.9967 14.9375C15.9967 14.9375 14.0226 3.16146 14.0108 3.08073C14.0004 3 13.9193 2.95573 13.8529 2.95052Z"
                            fill="#6F757E"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.48059 5.14578L7.91843 7.00124C7.91843 7.00124 7.29136 6.74994 6.5492 6.79031C5.4603 6.8515 5.4485 7.45697 5.45882 7.60932C5.51784 8.43874 7.99073 8.61973 8.1309 10.5637C8.24009 12.0924 7.21168 13.138 5.73031 13.2213C3.95237 13.3203 2.97266 12.3945 2.97266 12.3945L3.3489 10.9804C3.3489 10.9804 4.33452 11.6367 5.12242 11.5924C5.63736 11.5637 5.82179 11.194 5.80261 10.9322C5.72588 9.8502 3.71039 9.914 3.5835 8.13536C3.47579 6.63926 4.58977 5.12234 7.04791 4.98562C7.99663 4.93223 8.48059 5.14578 8.48059 5.14578Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="text-end">
                    <button type="submit">Save</button>
                  </div>
                </div>
              </form>
            </div>
            <div className="edit_pricing_wepper">
              <h3>Pricing</h3>
              <form>
                <div className="container">
                  <div className="row from_wepper">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="fname">Product Price</label>
                        <div className="add_user_input">
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Price "
                          />
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                          >
                            <path
                              d="M15.5274 0H3.46875V2.39574H7.72122C9.2829 2.39574 10.6149 3.39718 11.1093 4.79149H3.46875V7.18723H11.1093C10.6149 8.58154 9.2829 9.58298 7.72122 9.58298H3.46875V11.9787L10.49 19L12.184 17.3059L6.85687 11.9788H7.72122C10.6136 11.9788 13.0337 9.91781 13.5902 7.18727H15.5274V4.79153H13.5902C13.4099 3.90684 13.0339 3.09255 12.5097 2.39578H15.5274V0Z"
                              fill="#6F757E"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="fname">is featured?</label>
                        <div className="add_user_input">
                          <select
                            name="Yes/No"
                            className="form-control"
                            fdprocessedid="otsamo"
                          >
                            <option defaultValue="Yes/No">Yes/No</option>
                            <option defaultValue="2121">2125</option>
                            <option defaultValue="8745">8569</option>
                          </select>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M0 4.88667L1.886 3L8.00267 9.226L14.114 3L16 4.88667L8.00267 13L0 4.88667Z"
                              fill="#6F757E"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="fname">Product Status</label>
                        <div className="add_user_input">
                          <select
                            name="Select"
                            className="form-control"
                            fdprocessedid="otsamo"
                          >
                            <option defaultValue="Select">Select</option>
                            <option defaultValue="2121">2125</option>
                            <option defaultValue="8745">8569</option>
                          </select>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M0 4.88667L1.886 3L8.00267 9.226L14.114 3L16 4.88667L8.00267 13L0 4.88667Z"
                              fill="#6F757E"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="fname">Product Type</label>
                        <div className="add_user_input">
                          <select
                            name="Select"
                            className="form-control"
                            fdprocessedid="otsamo"
                          >
                            <option defaultValue="Ex. Card, Hamper">
                              Ex. Card, Hamper
                            </option>
                            <option defaultValue="2121">2125</option>
                            <option defaultValue="8745">8569</option>
                          </select>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M0 4.88667L1.886 3L8.00267 9.226L14.114 3L16 4.88667L8.00267 13L0 4.88667Z"
                              fill="#6F757E"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="fname">Product Attribute</label>
                        <div className="add_user_input">
                          <select
                            name="Select"
                            className="form-control"
                            fdprocessedid="otsamo"
                          >
                            <option defaultValue="Multi Select">
                              Multi Select
                            </option>
                            <option defaultValue="2121">2125</option>
                            <option defaultValue="8745">8569</option>
                          </select>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M0 4.88667L1.886 3L8.00267 9.226L14.114 3L16 4.88667L8.00267 13L0 4.88667Z"
                              fill="#6F757E"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="container">
                        {/* Toggle checkbox */}
                        <div className="col-lg-12">
                          <div className="customer_requirement_wepper edit_profile_togle">
                            <p>
                              Is Customer Requirement Needed? (Like do we need
                              any name or photos)
                            </p>
                            <div className="toggle-row">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  id="toggle2"
                                  checked={isToggleChecked}
                                  onChange={handleToggleChange}
                                />
                                <span className="slider"></span>
                              </label>
                            </div>
                          </div>
                        </div>

                        {/* Additional Requirement Count - Only visible when toggle is checked */}
                        {isToggleChecked && (
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label htmlFor="fname">
                                Additional Requirement Count
                              </label>
                              <div className="add_user_input">
                                <div className="counter-box increment_btn_wepper">
                                  <input
                                    type="text"
                                    placeholder={count === 0 ? "Add Count" : ""}
                                    className="count_input form-control"
                                    defaultValue={count === 0 ? "" : count}
                                    readOnly
                                  />
                                  <div className="buttons">
                                    <button
                                      className="btn increment"
                                      onClick={(event) => {
                                        event.preventDefault(); // Prevent default form submission
                                        setCount(count + 1);
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="15"
                                        height="15"
                                        viewBox="0 0 32 32"
                                        fill="none"
                                      >
                                        <path
                                          d="M16 2V30M2 16H30"
                                          stroke="#fff"
                                          strokeWidth="4"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </button>
                                    <button
                                      className="btn decrement"
                                      onClick={(event) => {
                                        event.preventDefault(); // Prevent default form submission
                                        if (count > 0) setCount(count - 1);
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="15"
                                        height="15"
                                        viewBox="0 0 32 4"
                                        fill="none"
                                      >
                                        <path
                                          d="M2 2H30"
                                          stroke="#fff"
                                          strokeWidth="4"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {rows.map((_, index) => (
                      <div className="row" key={index}>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label htmlFor="fname">1st Text Required</label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="name"
                                className="form-control"
                                placeholder="EX.- Provide name"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="form-group">
                            <label htmlFor="fname">
                              Additional Requirement type
                            </label>
                            <div className="add_user_input">
                              <select name="Select" className="form-control">
                                <option defaultValue="EX.- Provide name">
                                  EX.- Provide name
                                </option>
                                <option defaultValue="2121">2125</option>
                                <option defaultValue="8745">8569</option>
                              </select>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M0 4.88667L1.886 3L8.00267 9.226L14.114 3L16 4.88667L8.00267 13L0 4.88667Z"
                                  fill="#6F757E"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="form-group">
                            <label htmlFor="fname">
                              Additional Requirement Text Should
                            </label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="name"
                                className="form-control"
                                placeholder="EX.- Provide name"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </form>
            </div>
            <div className="edit_weeper_delete_sec_wepper">
              <h3>Delete Product</h3>
              <p>
                When you delete your product, you lose access to their previous
                records, and we permanently delete your product data. You can
                cancel the deletion for 14 days.
              </p>
              <form action="">
                <div className="form-group">
                  <input type="checkbox" id="Confirm_delete" />
                  <label htmlFor="Confirm_delete">
                    Confirm that i want to delete my account
                  </label>
                </div>
                <div className="delete_produt_wepper">
                  <input type="button" defaultValue={"Learn more"} />
                  <input
                    type="button"
                    className="active"
                    defaultValue={"Delete"}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </AdminLayout>
    </div>
  );
};

export default EditProduct;
